// Visszajátszás: a letöltött idősorból bármely pillanat állapota, ugyanazzal a
// logikával, ahogy az élő nézet abban a pillanatban mutatta volna.

const toTime = (value) => new Date(value).getTime();

// Technikai locationönként az adott pillanat előtti utolsó takarítás a határidejével.
export function cleaningStatesAt(cleanings = [], at) {
  const latest = new Map();
  cleanings.forEach((cleaning) => {
    const cleanedAt = toTime(cleaning.cleaned_at);
    if (cleanedAt > at) return;
    const key = String(cleaning.technical_location_id);
    const current = latest.get(key);
    if (!current || cleanedAt > toTime(current.cleaned_at)) latest.set(key, cleaning);
  });
  return [...latest.values()].map((cleaning) => ({
    technical_location_id: cleaning.technical_location_id,
    location_id: cleaning.location_id,
    cleaned_at: cleaning.cleaned_at,
    deadline_at: cleaning.deadline_at,
  }));
}

// Device-onként az adott pillanat előtti utolsó loctag-olvasás helye, és az a személy,
// aki abban a pillanatban be volt jelentkezve az eszközre.
export function devicePositionsAt(
  { reads = [], sessions = [] },
  at,
  { loctags = [], rects = [], people = [], devices = [] } = {}
) {
  const lastReadByDevice = new Map();
  reads.forEach((read) => {
    const time = toTime(read.time);
    if (time > at) return;
    const current = lastReadByDevice.get(read.device_id);
    if (!current || time > toTime(current.time)) lastReadByDevice.set(read.device_id, read);
  });

  const loctagById = new Map(loctags.map((tag) => [String(tag.id), tag]));
  const locationById = new Map(rects.map((location) => [String(location.id), location]));
  const personById = new Map(people.map((person) => [String(person.user_id), person]));
  const deviceById = new Map(devices.map((device) => [device.device_id, device]));

  const positions = [];
  lastReadByDevice.forEach((read, deviceId) => {
    const loctag = loctagById.get(String(read.loctag_id));
    const location = loctag && locationById.get(String(loctag.location_id));
    if (!location) return;
    const relative = loctag.relative_position || { x: 0, y: 0 };
    const session = sessions.find((item) => (
      item.device_id === deviceId
      && toTime(item.login_at) <= at
      && (!item.logout_at || toTime(item.logout_at) > at)
    ));
    const person = session ? personById.get(String(session.user_id)) : null;
    positions.push({
      deviceId,
      x: location.x + relative.x,
      y: location.y + relative.y,
      isDefaultPosition: false,
      deviceName: deviceById.get(deviceId)?.device_name || deviceId,
      userId: session?.user_id || null,
      userName: person?.name || person?.email || session?.user_name || null,
      userPhotoUrl: person?.photo_url || null,
    });
  });
  return positions;
}
